import {
  LiabilityPaymentHistoryEntry,
  LiabilityPaymentStatus,
} from "../../../types";

/** How many rows are revealed per "Load more" step, matching the desktop control. */
export const PAGE_SIZE = 10;

export const STATUS_LABEL: Record<LiabilityPaymentStatus, string> = {
  [LiabilityPaymentStatus.SCHEDULED]: "Scheduled",
  [LiabilityPaymentStatus.OVERPAYMENT]: "Overpayment",
  [LiabilityPaymentStatus.LATE]: "Late",
};

/** Newest-first display order; the API returns payments chronologically (oldest first). */
export const orderNewestFirst = (
  payments: LiabilityPaymentHistoryEntry[],
): LiabilityPaymentHistoryEntry[] => [...payments].reverse();

export const sumPaid = (payments: LiabilityPaymentHistoryEntry[]): number =>
  payments.reduce((total, payment) => total + payment.amount, 0);
